import { Link } from '@muse-web/router'

import { Badge, EyeClosedIcon, Tag } from '@ds/components'
import type { TCollectionTagLink } from '@features/collection'

import styles from './CollectionTags.module.css'

export type TCollectionTagsProps = {
    isUnlisted: boolean
    typeLabel: string
    /** Every tag, uncapped — the hero has no "+N" chip, unlike the card. */
    links: TCollectionTagLink[]
}

const renderTag = ({ label, href }: TCollectionTagLink, index: number) =>
    href ? (
        <Link key={`${index}-${label}`} href={href} className={styles.link}>
            <Tag>{label}</Tag>
        </Link>
    ) : (
        <Tag key={`${index}-${label}`}>{label}</Tag>
    )

export const CollectionTags = ({ isUnlisted, typeLabel, links }: TCollectionTagsProps) => (
    <div className={styles.tags}>
        {isUnlisted ? <Badge variant="default" Icon={EyeClosedIcon} /> : null}
        {typeLabel ? <Badge variant="default">{typeLabel}</Badge> : null}
        {links.map(renderTag)}
    </div>
)
